import useConference from "@/hooks/useConference";
import { Modal } from "antd";
import { useRouter } from "next/router";
import { useMemo } from "react";

interface IVideos {
  [key: string]: {
    url: string;
    label: string;
  };
}

export default function UserGuideVideo() {
  const router = useRouter();

  const {isConference} = useConference();

  const videos: IVideos = useMemo(() => {
    return {
      ["global-search"]: {
        url: "https://myconnect-public.s3.us-east-1.amazonaws.com/public-asset/Global+Search.mp4",
        label: "Global Search",
      },
      ["invite-champions"]: {
        url: isConference ? "https://myconnect-public.s3.us-east-1.amazonaws.com/public-asset/Invite+Champions(v2).mp4" : "https://myconnect-public.s3.us-east-1.amazonaws.com/public-asset/Invite+Champions.mp4",
        label: "Invite Champions",
      },
      ["make-connections"]: {
        url: "https://myconnect-public.s3.us-east-1.amazonaws.com/public-asset/Make+Connections.mp4",
        label: "Make Connections",
      },
      ["manage-your-goals"]: {
        url: "https://myconnect-public.s3.us-east-1.amazonaws.com/public-asset/Manage+Your+Goals.mp4",
        label: "Manage Your Goals",
      },
      ["complete-profile"]: {
        url: isConference ? "https://myconnect-public.s3.us-east-1.amazonaws.com/public-asset/Complete+your+Profile(v2).mp4" : "https://myconnect-public.s3.us-east-1.amazonaws.com/public-asset/Complete+Your+Profile.mp4",
        label: "Complete Your Profile",
      },
      ["create-mentorship"]: {
        url: isConference ? "https://myconnect-public.s3.us-east-1.amazonaws.com/public-asset/Create+Mentorships+(v2).mp4" : "https://myconnect-public.s3.us-east-1.amazonaws.com/public-asset/Create+Mentorships.mp4",
        label: "Create Mentorhips",
      },
      ["set-goals"]: {
        url: isConference ? "https://myconnect-public.s3.us-east-1.amazonaws.com/public-asset/Set+Goals+(v2).mp4" : "https://myconnect-public.s3.us-east-1.amazonaws.com/public-asset/Set+Goals.mp4",
        label: "Set Goals",
      },
      ["focused-milestone"]: {
        url: "https://myconnect-public.s3.us-east-1.amazonaws.com/public-asset/Focused+Milestone.mp4",
        label: "Focused Milestone",
      },
      ["login"]: {
        url: "https://myconnect-public.s3.amazonaws.com/public-asset/short+How+to+Use+My+Connect.mp4",
        label: "",
      },
    };
  }, [isConference]);

  const isShowing = useMemo(() => {
    if (
      Object.keys(videos).includes(router.query?.["userguidevideo"] as string)
    ) {
      return {
        isShowing: true,
        url: videos?.[router.query?.["userguidevideo"] as keyof IVideos]?.url,
        title:
          videos?.[router.query?.["userguidevideo"] as keyof IVideos]?.label,
      };
    }
    return { isShowing: false, url: "", title: "" };
  }, [router]);

  if (!isShowing.isShowing) return null;
  return (
    <Modal
      open
      width={"85%"}
      footer={null}
      title={isShowing?.title}
      onCancel={() => {
        let queries = { ...router.query };
        delete queries?.userguidevideo;
        router.push({ pathname: router.pathname, query: queries });
      }}
    >
      <iframe
        width="100%"
        className="h-[35vh] lg:h-[50vh] xl:h-[75vh]"
        src={isShowing?.url}
        allowFullScreen
      />
    </Modal>
  );
}
